export enum DiscountType {
  'G' = 'od obrotu',
  'R' = 'do transakcji - centrala',
  'P' = 'stała cena',
  'S' = 'składany'
}



// WEBPACK FOOTER //
// C:/projektyWeb/McComp_Flota/Front/src/app/dictonaries/discount-type.enum.ts